import type {SidePanelIssue} from '@github-ui/issues-shared/side-panel-url'

const PARENT_LIST_SELECTOR = '[data-testid="list-view-items"], [role="tree"], [role="list"], ul, ol'

export function resolveParentListTarget(element: HTMLElement | null): HTMLElement | null {
  return element?.closest<HTMLElement>(PARENT_LIST_SELECTOR) ?? null
}

export function findParentListTargetForIssue(issue: SidePanelIssue): HTMLElement | null {
  if (!issue.owner || !issue.repo) return null
  const expectedPath = `/${issue.owner}/${issue.repo}/issues/${issue.number}`
  for (const link of document.querySelectorAll<HTMLAnchorElement>('a[href]')) {
    if (link.closest('#issue-viewer-side-panel')) continue
    try {
      if (new URL(link.href, window.location.origin).pathname === expectedPath) return resolveParentListTarget(link)
    } catch {
      continue
    }
  }
  return null
}

export function focusParentListTarget(target: HTMLElement | null): (() => void) | undefined {
  if (!target?.isConnected) return
  if (target.hasAttribute('tabindex')) {
    target.focus()
    return
  }

  // Lists need a temporary tab stop so focus can move there after the clicked row disappears.
  target.tabIndex = -1
  const cleanup = () => {
    target.removeEventListener('blur', cleanup)
    target.removeAttribute('tabindex')
  }
  target.addEventListener('blur', cleanup, {once: true})
  target.focus()
  if (document.activeElement !== target) cleanup()
  return cleanup
}
